import apiService from "./apiService";


const AUTH_ERROR_STATUSES = [401, 403];

// function to fetch upcoming games 
export const fetchUpcomingGames = async(route) => {
    try {
        const response = await apiService(route);
        return response;
    } catch(error) {
        // Rethrow authentication errors to be handled by the caller
        if(AUTH_ERROR_STATUSES.includes(error.status) || error.message === 'Session Expired') {
            throw error;
        }

        if(error.status !== 304) {
            // Log other errors and return null
            console.error(`Failed to fetch upcoming games (${error.status}):`, error.message);
        }

        return null;
    }
};

export const fetchUserSubscription = async(user_id) => {
    try {
        const response = await apiService('payments/get-subscription', "POST", { user_id }, {});
        return response;
    } catch(error) {
        // Rethrow authentication errors to be handled by the caller
        if(AUTH_ERROR_STATUSES.includes(error.status) || error.message === 'Session Expired') {
            throw error;
        }

        if(error.status !== 304) {
            // Log other errors and return null
            console.error(`Failed to fetch user subscription (${error.status}):`, error.message);
        }

        return null;
    }
};